import { isDropDownATypeahead } from 'AppSrc/core/components/forms/form-base-components/sub-components/drop-down-components/templates/dropdown-templates';


const getTypeaheadDisplayOptions = (params) => {
  const {
    state,
    optionTemplate,
    fieldId,
  } = params;

  if (!isDropDownATypeahead(optionTemplate)) {
    return [];
  }

  const typeaheadLists = state.typeaheadList.typeaheadListsById[fieldId];

  if (!typeaheadLists) {
    return [];
  }

  const {
    displayList,
    displayListFiltered,
  } = typeaheadLists;

  if (!displayListFiltered) {
    return [];
  }

  if (displayList.length > 0) {
    return ([
      {
        category: 'Searched Results',
        values: displayList,
      },
    ]);
  }

  return [{
    category: 'No search results found',
    values: [],
  }];

};




const getFetchedDisplayOptions = (params) => {
  const {
    state,
    optionTemplate,
    fieldId,
  } = params;

  if (isDropDownATypeahead(optionTemplate)) {
    return [];
  }


  const displayOptionsDataForId = state.displayOptions.displayOptionsDataById[fieldId];


  if (!displayOptionsDataForId) {
    return [];
  }

  const {
    displayOptions,
    displayList,
  } = displayOptionsDataForId;

  const displayListAsdisplayOptions = displayList.map((displayOption) => ({
    text: displayOption,
    value: displayOption,
  }));


  return displayOptions.length > 0 ? displayOptions : displayListAsdisplayOptions;

};

const getDisplayOptionsFromRedux = (params) => {
  const {
    state,
    optionTemplate,
    fieldId,
  } = params;

  const typeaheadDisplayOptions = getTypeaheadDisplayOptions({
    state,
    optionTemplate,
    fieldId,
  });

  const fetchedDisplayOptions = getFetchedDisplayOptions({
    state,
    optionTemplate,
    fieldId,
  });


  return [
    ...typeaheadDisplayOptions,
    ...fetchedDisplayOptions,
  ];

};

export { getDisplayOptionsFromRedux };
